import useUserLocation from 'global-state/userLocation/useUserLocation';
import {
  formatCityForMeta,
  formatStateForMeta,
  formatZipForMeta,
} from './helpers/formatLocationDataForMeta';

const useMetaFormattedCityStateZip = () => {
  const { zip, city, stateShortName: state } = useUserLocation();
  const formattedZip = formatZipForMeta(zip);
  const formattedState = formatStateForMeta(state);
  const formattedCity = formatCityForMeta(city);

  return { formattedCity, formattedState, formattedZip };
};

export default useMetaFormattedCityStateZip;
